<template>
 <div style="height:100%"><FileList :assocID="assocID" :module="module"></FileList></div>
</template>
<script>
import FileList from "./FileList";
export default {
  name: "FileManage",
  controller: "UI",
  action: "FileManage",
  components:{
    FileList
  },
  data() {
      return{
        assocID:"wenjianguanl",
        module:"文件管理"
      }
  },
  created:function() {
  },
  mounted: function() {   
  },
  methods: {
  }
}
</script>
